import RoutingActions from '../../../actions/RoutingActions';
import GuestListActions from '../../../actions/GuestListActions';
import PopupActions from '../../../actions/PopupActions';
import NotificationActions from '../../../actions/NotificationActions';

import ConfirmPopup from '../../common/ConfirmPopup.react';
import GuestListStore from '../../../stores/GuestListStore';

class CheckOut extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading : false
        };

        this.checkGuestOut = this.checkGuestOut.bind(this);
        this.onGuestListStoreChange = this.onGuestListStoreChange.bind(this);
    }

    componentDidMount() {
        GuestListStore.addChangeListener(this.onGuestListStoreChange);
    }

    componentWillUnmount() {
        GuestListStore.removeChangeListener(this.onGuestListStoreChange);
    }

    onGuestListStoreChange() {
        if (!this.state.loading)
            return;

        var self = this;

        this.setState({ loading : false }, () => {
            if (!GuestListStore.getGuestById(self.props.guest.Guest_id)) {
                setTimeout(() => {
                    RoutingActions.updateRoute('guest-list');
                    PopupActions.close();
                }, 10);
            }
        });
    }

    checkGuestOut() {
        var self = this;

        if (this.state.loading || this.props.loading)
            return;

        this.setState({ loading : true }, () => {
            GuestListActions.checkGuestOut(self.props.guest);
        });
    }

    render() {
        var label = this.props.selectedLocation.CompanyFlag === 'Dispensary' ? 'REMOVE FROM LIST' : 'REMOVE FROM LIST';

        return [
            <button
                className='btn-green'
                onClick={() => this.setState({ confirmRemoval: true }) }>

                { this.state.loading ? 'Loading' : label }
            </button>,
            this.state.confirmRemoval &&
            <div className='popup'>
                <div className='popup__content remove-from-list__clear'>
                    <div className='popup-header'>
                        REMOVE FROM LIST?
                        <div
                            className='popup-close'
                            onClick={() => { this.setState({ confirmRemoval: false }); }}>

                            <i className='fa fa-times' aria-hidden='true' />
                        </div>
                    </div>

                    <button
                        onClick={() => { this.setState({ confirmRemoval: false }); }}>

                        CANCEL
                    </button>

                    <button
                        onClick={this.checkGuestOut}>

                        CONFIRM
                    </button>
                </div>
            </div>,
        ];
    }
}

export default CheckOut;


// WEBPACK FOOTER //
// ./ui_src/app/components/profile/sidebar/CheckOut.react.jsx